import styled from 'styled-components';
import { Button, Col, Form, Row, Tooltip } from 'antd';
import { Title } from '@/components/Typography';

export const HeaderRow = styled(Row)`
	margin-top: 1.5625rem;
	margin-bottom: 2.5rem;
`;

export const HeaderTitle = styled(Title)`
	&& {
		margin: 0;
		color: ${({ theme }) => theme.palette.secondary[400]};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_2xl};
	}

	text-align: center;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	@media (min-width: 576px) {
		white-space: normal;
		overflow: visible;
		text-overflow: clip;
	}
`;

export const FooterRow = styled(Row)`
	min-width: 190px;
	margin-top: 2.5rem;
`;

export const GeneralInformationsForm = styled(Form)`
	width: 100%;
	padding-bottom: 0.5rem;

	.ant-form-item {
		margin-bottom: 2rem;
	}

	.ant-form-item-label > label {
		height: auto;
	}
`;

export const PreviousCol = styled(Col)`
	padding: 0;
	margin-right: 1rem;
`;

export const CustomTooltip = styled(Tooltip)`
	position: relative;
	padding: 0 0.7rem;
	background-color: #cdd5f3;
	border-radius: 0.25rem;
`;

export const CustomButton = styled(Button)`
	margin-bottom: 1rem;
	@media (min-width: 1470px) {
		margin-left: 0.8rem;
	}
	transition: all 0.2s;
	:hover {
		filter: brightness(0.9);
		background-color: #cdd5f3;
	}
`;
